<template>
  <span :class="pillClasses">{{ SHARING_LEVEL_VARIANT_LABEL[variant] }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { SHARING_LEVEL_VARIANT_LABEL } from '../sharingLevelVariantLabels';
import type { SharingLevelVariantType } from '../types';

const { variant } = defineProps<{ variant: SharingLevelVariantType }>();

const VARIANT_CLASS: Record<SharingLevelVariantType, string> = {
  all: 'partner-tab-sharing-level-pill--all',
  overlaps: 'partner-tab-sharing-level-pill--overlaps',
  counts: 'partner-tab-sharing-level-pill--counts',
  hidden: 'partner-tab-sharing-level-pill--hidden',
  request: 'partner-tab-sharing-level-pill--request',
  pending: 'partner-tab-sharing-level-pill--pending',
};

const pillClasses = computed(() => [
  'partner-tab-sharing-level-pill',
  VARIANT_CLASS[variant],
]);
</script>

<style lang="pcss">
@reference "../../../../css/theme.css";
.partner-tab-sharing-level-pill {
  @apply flex items-center justify-center h-full w-full rounded-4 px-6 text-sm;
}
.partner-tab-sharing-level-pill--all {
  @apply bg-info-background-weak/50 text-info-text mix-blend-multiply;
}
.partner-tab-sharing-level-pill--overlaps {
  @apply bg-success-background-weak/50 text-success-text mix-blend-multiply;
}
.partner-tab-sharing-level-pill--counts {
  @apply bg-warning-background-weak/50 text-warning-text mix-blend-multiply;
}
.partner-tab-sharing-level-pill--hidden {
  @apply bg-danger-background-weak/50 text-danger-text mix-blend-multiply;
}
.partner-tab-sharing-level-pill--request {
  @apply border border-dashed border-neutral-border font-semibold text-neutral-text;
}
.partner-tab-sharing-level-pill--pending {
  @apply bg-neutral-background/25 text-neutral-text-weak;
}
</style>
